import api from '../utils/axiosConfig';

export const submitPreferences = async (preferences) => {
  try {
    const response = await api.post('/preferences/submit/', preferences); // Matches your urls.py: 'submit/'
    return response.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const setCompanyShortlists = async (shortlistData) => {
  try {
    const response = await api.patch('/preferences/pu_admin/set_company_shortlists/', shortlistData); // Matches your urls.py
    return response.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const getUserPreferences = async () => {
  try {
    const response = await api.get('/preferences/personal/preferences/'); // Matches new endpoint
    return response.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};